import { createScopedLogger } from 'pi-kiosk-shared/logging';
import { customerLogger } from '../../shared/logging/customerLogger.js';

export const postKioskLog = createScopedLogger(customerLogger, { module: 'journeys', feature: 'postKiosk' });
